import React, { useState, useRef, useEffect, useCallback } from "react"
import GoogleMapReact from "google-map-react"
import useSupercluster from "use-supercluster"
// import "./App.css";
import { connect } from "react-redux"
import Icon from "../../images/map-icon.png"
import Card_Property from "../property-card"
import Card_Development from "../development-card"
import { graphql, useStaticQuery } from "gatsby"
import mapStyles from "../mapStyles.json"
import { getPrices } from "../../helpers/helper.properties"
import { getPriceForMarker } from "../../helpers/helper.rendering"
import {
  getType,
  getOperationView,
  textTypes,
  makeParamsGetByFilters,
  makeFormDataByFilters,
  makeParamsCoordinates,
  makeParamsByFiltersMediacore,
} from "../../helpers/helper.filters"
import {
  deleteSharp,
  handlerClick,
  reCalculateCoordinateMarkers,
  scrollOnGrid,
} from "../../helpers/helper.map"
import Paginate from "../paginate"
import $ from "jquery"
import { useLocation } from "@reach/router"
import PENCIL from "../../images/pencil.png"
import Loader from "../LoaderMap"
import TrashSvg from "../../images/svg/trash.svg"
import { addMarker, checkMarker, getMarkers } from "../../helpers/helper.map"
import {
  redux_updateOrders,
  REDUX_UPDATE_COORDINATES,
  getPropertiesAction,
  changeSelectedAction,
  changeOffsetPropertiesAction,
  REDUX_UPDATE_POLYGON_COORDINATES,
  REDUX_UPDATE_DRAWN_POLYGON,
} from "../../redux/propertiesDucks"
import Filters from "./filters"
import { select } from "async"
import {
  MapContainer,
  TileLayer,
  Marker as MarkerLeaflet,
  Popup,
  ZoomControl,
  useMap,
  FeatureGroup,
} from "react-leaflet"
// import "bootstrap/dist/js/bootstrap.bundle.min"
import { EditControl } from "react-leaflet-draw"
import "leaflet-draw/dist/leaflet.draw.css"
import L from "leaflet"
import useQueryProperties from "../../hooks/useQueryProperties"
// import "npm-overlapping-marker-spiderfier";

function changeFormat(value) {
  if (value) {
    var convert = value.toString()
    return convert.replace(",", ".")
  }
}

const icons = {}

const fetchIcon = (count, size) => {
  if (!icons[count]) {
    icons[count] = L.divIcon({
      html: `<div class="cluster-marker" style="width: ${size}px; height: ${size}px;">
        ${count}
      </div>`,
    })
  }
  return icons[count]
}

const Marker = ({ children }) => children

function getMap(props) {
  const { realEstate } = useStaticQuery(graphql`
    query {
      realEstate {
        keys {
          google_map
          tokko
        }
        env {
          CLIENTID
        }
      }
    }
  `)

  const {
    // properties,
    filters,
    offset,
    dispatch,
    coordinates,
    drawnPolygon,
    selected,
    viewId,
    setMenu,
    polygonCoordinates,
  } = props

  const mapOptions = {
    styles: mapStyles,
    zoomControl: true,
    maxZoom: 17,
    fullscreenControl: false,
    scrollwheel: true,
  }

  const [mapBorder, setMapBorder] = useState()
  const [coordinatesCheck, setCoordinatesCheck] = useState()
  const [sidebar, setSidebar] = useState(true)

  const [nodeElement, setNode] = useState(false)
  const [firstCenter, setFirstCenter] = useState(true)
  const location = useLocation()

  const [scrolling, setScrolling] = useState(false)

  const [points, setPoints] = useState([])
  const [maxPropertiesLoaded, setMaxPropertiesLoaded] = useState(50)
  const [limitedProperties, setLimitedProperties] = useState([])
  const [clickedProperties, setClickedProperties] = useState([])
  const [skipCenter, setSkipCenter] = useState(false)

  const [backup, setBackup] = useState([])

  const [mapLeaflet, setMapLeaflet] = useState([])
  const [currentBoundsLeaflet, setCurrentBoundsLeaflet] = useState([])
  const [boundsLeaflet, setBoundsLeaflet] = useState([])
  const [isFirstRender, setIsFirstRender] = useState(true)

  const mapRef = useRef()
  const google = useRef()
  const [bounds, setBounds] = useState(null)
  const [center, setCenter] = useState({ lat: -34.5275818, lng: -58.5052437 })
  const [notCenter, setNotCenter] = useState(false)
  const [zoom, setZoom] = useState(11)
  const [drawing, setDrawing] = useState(false)
  const [barControllMap, setBarControllMap] = useState(null) //null - polygon - pencil
  const [shape, setShape] = useState()

  const [orders, setOrders] = useState({ order: "desc", order_by: "id" })
  const selectorOrder = useRef()

  const [recalcularedProperties, setRecalculedProperties] = useState([])
  const [backupProperties, setBackupProperties] = useState([])

  //Variable para abrir card
  const [activeMarker, setActiveMarker] = useState(null)

  // const { data: propertiesOld, isLoading: isLoadingProperties, isFetching: isFetchingProperties } = useGetPropertiesQuery({
  //   "API_KEY":realEstate.keys.tokko,
  //   "params_get":makeParamsGetByFilters(orders,offset,polygonCoordinates) + makeFormDataByFilters(filters,coordinates,polygonCoordinates),
  //   "body":makeParamsCoordinates(coordinates,polygonCoordinates)
  // });

  const {
    properties,
    isLoading: isLoadingProperties,
    isFetching: isFetchingProperties,
  } = useQueryProperties({
    filters,
    polygonCoordinates,
    coordinates,
    orders,
    offset,
  })

  useEffect(() => {
    if (
      screen.width < 992 &&
      (barControllMap === "pencil" || barControllMap === "polygon")
    ) {
      document.body.classList.add("overflow-pencil")
    } else {
      document.body.classList.remove("overflow-pencil")
    }
  }, [barControllMap])

  const checkAndSetActive = id => {
    if (activeMarker === id) {
      setActiveMarker(0)
      return null
    }
    setActiveMarker(id)
    return null
  }

  const { clusters, supercluster } = useSupercluster({
    points,
    bounds,
    zoom,
    // options: { radius: 100, maxZoom: 17 },
    options: { radius: 100 },
  })

  const searchUnitiesInResults = id => {
    let result = properties?.objects?.filter(
      property => property.development?.id === id
    )
    return result
  }

  const handleGoogleMapApi = (map, google) => {
    if (google.drawing) {
      const drawingManager = new google.drawing.DrawingManager({
        drawingMode: null,
        drawingControl: false,
        drawingControlOptions: {
          position: google.ControlPosition.TOP_LEFT,
          drawingModes: [google.drawing.OverlayType.POLYGON],
        },
      })

      google.event.addListener(
        drawingManager,
        "overlaycomplete",
        function (event) {
          //Listener para cuando se hace click en el marcador, se borra el marcador
          var element = event.overlay
          let polygon = []
          // dispatch(REDUX_UPDATE_DRAWN_POLYGON(element)) // Esto es una prueba.
          if (shape !== undefined) {
            shape.setMap(null)
          }
          setShape(element)
          if (event.type != google.drawing.OverlayType.MARKER) {
            // drawingManager.setDrawingMode(null);
            // drawingManager.setOptions({
            //   drawingControl: false
            // });
            setDrawing(true)
          }
          Object.values(element.latLngs.getArray()[0])[0].map((point, index) =>
            polygon.push({ lat: point.toJSON().lat, lng: point.toJSON().lng })
          )
          //Obtengo las coordenadas del polygon
          // Object.values(element.latLngs.getArray()[0])[0].map((point, index) =>
          //   polygon.push({ lat: point.toJSON().lat, lng: point.toJSON().lng })
          // )
          dispatch(REDUX_UPDATE_POLYGON_COORDINATES(polygon))
          drawingManager.setDrawingMode(null)
        }
      )
      google.event.addListener(map, "dblclick", e => {
        mapRef?.current?.panTo(e.latLng)
        setZoom(mapRef.current.zoom + 1)
      })

      //Función para eliminar el polygon
      google.event.addDomListener(
        document.getElementById("clean"),
        "click",
        function (e) {
          const newPolygonCoordinates = []
          dispatch(REDUX_UPDATE_POLYGON_COORDINATES(newPolygonCoordinates))
          drawingManager.setDrawingMode(null)
          setBarControllMap(null)
          setDrawing(false)
          enable()
        }
      )
      google.event.addDomListener(
        document.getElementById("button-polygon"),
        "click",
        function (e) {
          drawingManager.setDrawingMode(google.drawing.OverlayType.POLYGON)
          setDrawing(false)
          enable()
        }
      )
      google.event.addDomListener(
        document.getElementById("back-hand_"),
        "click",
        function (e) {
          drawingManager.setDrawingMode(null)
          setDrawing(false)
          enable()
        }
      )
      google.event.addDomListener(
        document.getElementById("back-hand"),
        "click",
        function (e) {
          drawingManager.setDrawingMode(null)
          setDrawing(false)
          enable()
        }
      )
      drawingManager.setMap(map)
    }
  }

  const handleSearchProperties = (isRectangle = false) => {
    if (mapBorder !== coordinatesCheck) {
      setNotCenter(true)
      dispatch(changeOffsetPropertiesAction(0))
      if (isRectangle) {
        setCoordinatesCheck(mapBorder)
        dispatch(REDUX_UPDATE_COORDINATES(mapBorder))
      }
      // dispatch(getPropertiesAction())
    }
  }

  function disable() {
    mapRef.current.setOptions({
      draggable: false,
      zoomControl: false,
      scrollwheel: false,
      disableDoubleClickZoom: false,
    })
  }

  function enable() {
    mapRef.current.setOptions({
      draggable: true,
      zoomControl: true,
      scrollwheel: true,
      disableDoubleClickZoom: true,
    })
  }

  const drawAction = e => {
    e.preventDefault()
    disable()
    setDrawing(true)

    if (screen.width < 992) {
      google.current.event.addDomListener(
        mapRef.current.getDiv(),
        "touchstart",
        function (e) {
          drawFreeHand()
        }
      )
    } else {
      google.current.event.addDomListener(
        mapRef.current.getDiv(),
        "mousedown",
        function (e) {
          drawFreeHand()
        }
      )
    }
  }

  function drawFreeHand() {
    //the polygon
    let poly = new google.current.Polyline({
      map: mapRef.current,
      clickable: false,
    })

    //move-listener
    var move = google.current.event.addListener(
      mapRef.current,
      "mousemove",
      function (e) {
        poly.getPath().push(e.latLng)
      }
    )

    //mouseup-listener
    google.current.event.addListenerOnce(
      mapRef.current,
      "mouseup",
      function (e) {
        google.current.event.removeListener(move)
        var path = poly.getPath()
        if (path.length > 0) {
          poly.setMap(null)
          poly = new google.current.Polygon({ map: mapRef.current, path: path })
          setShape(poly)
          // dispatch(REDUX_UPDATE_DRAWN_POLYGON(poly))
          let polygon = []
          Object.values(poly.latLngs.getArray()[0])[0].map((point, index) =>
            polygon.push({ lat: point.toJSON().lat, lng: point.toJSON().lng })
          )
          google.current.event.clearListeners(
            mapRef.current.getDiv(),
            "mousedown"
          )
          dispatch(REDUX_UPDATE_POLYGON_COORDINATES(polygon))
          handleSearchProperties()
          enable()
          setDrawing(false)
        }
      }
    )
  }

  const toggleFilterBar = () => {
    $(".sumary-filter").toggleClass("m-offset")
  }

  function traductorSelect() {
    switch (selectorOrder.current.value) {
      case "0":
        setOrders({ order: "desc", order_by: "price" })
        break
      case "1":
        setOrders({ order: "asc", order_by: "price" })
        break
      case "2":
        setOrders({ order: "desc", order_by: "id" })
        break
      case "3":
        setOrders({ order: "asc", order_by: "id" })
        break
      case "4":
        setOrders({ order: "desc", order_by: "total_surface" })
        break
      case "5":
        setOrders({ order: "asc", order_by: "total_surface" })
        break
    }
  }

  const centerMap = _points => {
    if (polygonCoordinates.length === 0 && _points?.length > 0) {
      // if(_points.length > 0){
      if (google.current && _points) {
        var boundes = new google.current.LatLngBounds()
        for (var i = 0; i < _points.length; i++) {
          var marker = new google.current.Marker({
            position: new google.current.LatLng(
              _points[i].geometry.coordinates[1],
              _points[i].geometry.coordinates[0]
            ),
            map: mapRef.current,
            visible: false,
          })
          boundes.extend(marker.getPosition())
        }
        mapRef.current.fitBounds(boundes)
      }
    }
    // if(polygonCoordinates.length > 0 && points.length > 0){
    //   setZoom(zoom - 1)
    // }
  }

  const cleanerPolygon = () => {
    shape?.setMap(null)
    setShape(undefined)
    if (drawnPolygon) {
      deleteSharp(drawnPolygon, dispatch, REDUX_UPDATE_DRAWN_POLYGON)
    }
    setCoordinatesCheck(undefined) // Elimino filtro por area local
    dispatch(REDUX_UPDATE_COORDINATES([])) // Elimino filtro por area global
    dispatch(REDUX_UPDATE_POLYGON_COORDINATES([]))
  }

  const getExpansionZoom = cluster => {
    const currentZoom = props.zoom || zoom
    const clusterExpansionZoom = supercluster.getClusterExpansionZoom(
      cluster.id
    )
    let zoom_custom = currentZoom
    for (let index = 0; index < clusterExpansionZoom - currentZoom; index++) {
      zoom_custom += 1
      mapRef.current.setZoom(zoom_custom)
    }
    // // mapRef.current.setZoom(Math.min(clusterExpansionZoom, currentZoom + 1));

    return Math.min(clusterExpansionZoom, currentZoom + 1)
  }

  useEffect(() => {}, [mapBorder])

  useEffect(() => {
    // dispatc(changeSelectedAction(0))
    dispatch(changeSelectedAction(activeMarker))
  }, [activeMarker])

  useEffect(() => {
    // if (selected && (!properties?.objects?.find(element => element.id === selected)?.development?.id > 0 || !properties?.objects?.find(element => element.id === selected)?.development?.display_on_web)
    // ) {
    //   const sideBarElement = document.getElementById("sidebarElement") // get id of sidebar
    //   const cardSelectedElement = $("#card-grid-" + selected).last() // get id of card
    //   var offsetCard = cardSelectedElement?.position()?.top // get offset of card
    //   setScrolling(true) // i say that app is scrolling
    //   sideBarElement.scrollTo({
    //     top: sideBarElement.scrollTop + offsetCard - 300,
    //     behavior: "smooth",
    //   }) // scroll to card
    // }
    // setScrolling(true)
    // setTimeout(function () {
    //   // i wait for the scroll to finish
    //   setScrolling(false)
    // }, 1000)
    if (selected === 0) {
      // setActiveMarker(0)
      if (viewId !== 1 && zoom > 13) {
        // setZoom(13)
        centerMap(points)
      }
    }
  }, [selected])

  useEffect(() => {
    let new_points = []
    let old_points = points
    reCalculateCoordinateMarkers(properties?.objects).map(property => {
      property.development ? (
        <>
          {new_points.find(
            element =>
              element.property.development?.id === property.development?.id &&
              property.development?.display_on_web
          )
            ? null
            : new_points.push({
                type: "Feature",
                property: property,
                properties: {
                  cluster: false,
                  propId: property.id,
                  address: property.address,
                },
                geometry: {
                  type: "Point",
                  coordinates: [
                    parseFloat(
                      changeFormat(
                        zoom > 16 && property.geo_long_changed
                          ? property.geo_long_changed
                          : property.geo_long
                      )
                    ),
                    parseFloat(
                      changeFormat(
                        zoom > 16 && property.geo_long_changed
                          ? property.geo_lat_changed
                          : property.geo_lat
                      )
                    ),
                  ],
                },
              })}
        </>
      ) : false ? null : (
        new_points.push({
          type: "Feature",
          property: property,
          properties: {
            cluster: false,
            propId: property.id,
            address: property.address,
          },
          geometry: {
            type: "Point",
            coordinates: [
              parseFloat(
                changeFormat(
                  zoom > 16 && property.geo_long_changed
                    ? property.geo_long_changed
                    : property.geo_long
                )
              ),
              parseFloat(
                changeFormat(
                  zoom > 16 && property.geo_long_changed
                    ? property.geo_lat_changed
                    : property.geo_lat
                )
              ),
            ],
          },
        }) +
        (property.offsetChanged &&
        zoom > 16 &&
        new_points.find(
          element =>
            element.geometry.coordinates[0] === property.geo_long_changed &&
            element.geometry.coordinates[1] === property.geo_lat_changed
        )
          ? new_points.push({
              type: "Feature",
              property: property,
              properties: {
                cluster: false,
                propId: property.id + Math.random,
                address: property.address,
                isCenterPoint: true,
              },
              geometry: {
                type: "Point",
                coordinates: [
                  parseFloat(changeFormat(property.geo_long)),
                  parseFloat(changeFormat(property.geo_lat)),
                ],
              },
            })
          : null)
      )
    })
    setPoints(new_points)
    if (old_points.length > 0 && new_points.length > 0) {
      if (new_points[0].properties.propId !== old_points[0].properties.propId) {
        if (polygonCoordinates.length === 0 && coordinates.length === 0) {
          setTimeout(() => {
            centerMap(new_points)
          }, 750)
        }
        // if (!notCenter && !skipCenter) {
        // }
        // setNotCenter(false)
      }
    } else if (old_points.length === 0 && new_points.length > 0) {
      setTimeout(() => {
        centerMap(new_points)
      }, 750)
    } else {
      // setPoints(new_points)
      if (!notCenter && !skipCenter) {
        // centerMap()
      }
      setNotCenter(false)
    }
    setSkipCenter(false)
  }, [properties, zoom, coordinates, polygonCoordinates])

  useEffect(() => {
    if (firstCenter && points.length > 0) {
      setTimeout(() => {
        centerMap(points)
      }, 2500)
      setFirstCenter(false)
    }
  }, [filters.operation, points])

  useEffect(() => {
    if (viewId !== 2) {
      dispatch(redux_updateOrders(orders))
    }
  }, [orders])

  // useEffect(() => {
  //   if (!notCenter) {
  //     centerMap()
  //   }
  //   setNotCenter(false)
  // }, [points])

  useEffect(() => {
    // setRecalculedProperties(reCalculateCoordinateMarkers(properties))
  }, [zoom])

  useEffect(() => {
    if (
      filters.environments?.length == 0 &&
      filters.environments?.length == 0 &&
      filters.environments_types.length == 0 &&
      filters.generals.length == 0 &&
      filters.location.length == 0 &&
      filters.price.type == "" &&
      filters.services.length == 0 &&
      filters.specials.length == 0 &&
      filters.surface.type == "" &&
      filters.type.length == 0
    ) {
      if (zoom > 10) {
        // setZoom(zoom === 13 ? 14 : 13)
      }
    }
  }, [filters])

  useEffect(() => {}, [limitedProperties])

  useEffect(() => {
    setBackupProperties(properties)
  }, [properties])

  useEffect(() => {
    if (selected) {
      // dispatch(changeSelectedAction(0))
    }
    if (
      polygonCoordinates.length === 0 &&
      coordinates.length === 0 &&
      mapRef?.current
    ) {
      cleanerPolygon()
      // centerMap(points)
    }
  }, [viewId])

  const openModal = boolean => {
    if (boolean === true) {
      // $('#exampleModal')[0].modal('toggle');
    }
  }
  const textUpper = text => text?.replace(text[0], text[0]?.toUpperCase())

  const getLimit = properties => {
    const response = []
    if (!properties) {
      return []
    }
    if (properties?.length > maxPropertiesLoaded) {
      for (let i = 0; i < properties.length; i++) {
        if (i < maxPropertiesLoaded) {
          response.push(properties[i])
        }
      }
      return order_properties_mediacore(response)
    }
    return order_properties_mediacore(properties)
    // return properties.filter(prop => prop?.development?.display_on_web !== true)
  }

  const order_properties_mediacore = properties => {
    if (!realEstate.keys.tokko) {
      let properties_order = properties.map(prop => prop)
      switch (orders.order_by) {
        case "id": {
          let response = properties_order.sort((a, b) => a.id - b.id)
          if (orders.order === "desc") {
            response.reverse()
          }
          return response
        }
        case "price": {
          let response = properties_order.sort(
            (a, b) =>
              a.operations.find(
                op =>
                  op.operation_type?.toLowerCase() ===
                  filters.operation
                    ?.toLowerCase()
                    .replace("temporario", "alquiler temporario")
              )?.prices?.price -
              b.operations.find(
                op =>
                  op.operation_type?.toLowerCase() ===
                  filters.operation
                    ?.toLowerCase()
                    .replace("temporario", "alquiler temporario")
              )?.prices?.price
          )
          if (orders.order === "desc") {
            response.reverse()
          }
          return response
        }
        case "total_surface": {
          let response = properties_order.map(prop => ({
            ...prop,
            surface_to_filter:
              prop.type.name === "Campo" || prop.type.name === "Terreno"
                ? prop.surface
                : prop.total_surface,
          }))
          console.log(response)
          response = response.sort(
            (a, b) => a.surface_to_filter - b.surface_to_filter
          )
          if (orders.order === "desc") {
            response.reverse()
          }
          return response
        }
        default:
          return properties
      }
    }
    return properties
  }

  // Leaflet

  const toggleModal = boolean => {
    const modal = document.getElementById("exampleModal")
    if (boolean === true) {
      modal.classList.add("show")
      modal.style.display = "block"
      document.body.classList.add("modal-open")
    } else {
      modal.classList.remove("show")
      modal.style.display = "none"
      document.body.classList.remove("modal-open")
    }
  }

  const CustomMarker = ({ position, cluster }) => {
    if (!cluster.property) {
      return <></>
    } // Caso de cluster
    const { property } = cluster
    const isDevelopment = property.development !== null
    let customMarkerLeaflet
    if (property.development !== null) {
      if (property.development.display_on_web === false) {
        return <></>
      }
      customMarkerLeaflet = L.divIcon({
        // Caso de que sea un enmprendimiento
        className:
          "crime-marker " +
          (cluster.properties.propId === selected && " selected-marker ") +
          (cluster.property.development.display_on_web && " is_development ") +
          (checkMarker(
            cluster.property.development?.id?.length > 1
              ? cluster.property.development?.id
              : cluster.properties.propId
          )
            ? " active "
            : ""),
        html:
          '<div class="custom-marker center"><i class="icon-marker-emprendimiento"></i><h5>' +
          searchUnitiesInResults(cluster.property.development?.id)?.length +
          '</h5><div class="delete-selected"></div></div>',
        iconSize: [45, 55],
      })
    } else {
      customMarkerLeaflet = L.divIcon({
        // Caso de que sea una propiedad
        className:
          "crime-marker " +
          (cluster.properties.isCenterPoint ? " center-marker " : "") +
          (filters.operation.includes("venta")
            ? " venta-marker "
            : " alquiler-marker ") +
          (selected?.toString() !== "0" &&
          cluster?.properties?.propId.toString() !== selected?.toString()
            ? " opacity-marker "
            : "") +
          (cluster.properties.propId === selected && " selected-marker ") +
          (checkMarker(
            cluster.property.development?.id?.length > 1
              ? cluster.property.development?.id
              : cluster.properties.propId
          )
            ? " active "
            : ""),
        html:
          '<div class="custom-marker center"><i class="icon-marker"></i><h5>' +
          getPriceForMarker(getPrices(cluster.property, filters.operation)) +
          '</h5><div class="delete-selected"></div></div>',
        iconSize: [45, 55],
      })
    }

    const handleMarkerClick = e => {
      dispatch(changeSelectedAction(cluster.properties.propId))
      addMarker(cluster.properties.propId)
      scrollOnGrid(cluster.properties.propId)
      if (isDevelopment || viewId === 1) {
        toggleModal(true)
      }
    }

    const handleMarkerMouseOver = () => {}

    const handleMarkerMouseOut = () => {}

    return (
      <MarkerLeaflet
        eventHandlers={{
          click: e => handleMarkerClick(e),
          mouseover: e => handleMarkerMouseOver(e),
          mouseout: e => handleMarkerMouseOut(e),
        }}
        icon={customMarkerLeaflet}
        position={position}
      ></MarkerLeaflet>
    )
  }

  const RenderMarkersLeaflet = () => {
    // const markerCoords = []; // arreglo para guardar coordenadas de marcadores
    const maxZoom = 18
    const [bounds, setBounds] = useState(null)
    const [zoom, setZoom] = useState(15)
    const map = useMap()
    const [pointsLeaflet, setPointsLeaflet] = useState([])
    const [trash, setTrash] = useState(false)

    const centerDynamic = (new_points = []) => {
      if (polygonCoordinates.length === 0 && coordinates.length === 0) {
        const markerCoords = [] // arreglo para guardar coordenadas de marcadores
        for (const iterator of new_points) {
          markerCoords.push([
            iterator.geometry.coordinates[1],
            iterator.geometry.coordinates[0],
          ]) // agregar coordenadas al arreglo
        }
        if (markerCoords.length) {
          // ajustar vista del mapa para incluir todos los marcadores
          map.fitBounds(markerCoords)
          if (map.getZoom() > 16) {
            map.setView(map.getCenter(), 15)
          }
        }
      }
    }

    useEffect(() => {
      let new_points = []
      reCalculateCoordinateMarkers(properties?.objects || properties).map(
        property => {
          property.development ? (
            <>
              {new_points.find(
                element =>
                  element.property.development?.id ===
                    property.development?.id &&
                  property.development?.display_on_web
              )
                ? null
                : new_points.push({
                    type: "Feature",
                    property: property,
                    properties: {
                      cluster: false,
                      propId: property.id,
                      address: property.address,
                    },
                    geometry: {
                      type: "Point",
                      coordinates: [
                        // parseFloat(changeFormat((property.geo_long_changed ? property.geo_long_changed : property.geo_long))),
                        // parseFloat(changeFormat((property.geo_lat_changed ? property.geo_lat_changed : property.geo_lat))),
                        parseFloat(changeFormat(property.geo_long)),
                        parseFloat(changeFormat(property.geo_lat)),
                      ],
                    },
                  })}
            </>
          ) : false ? null : (
            new_points.push({
              type: "Feature",
              property: property,
              properties: {
                cluster: false,
                propId: property.id,
                address: property.address,
              },
              geometry: {
                type: "Point",
                coordinates: [
                  // parseFloat(changeFormat((zoom > 17 && property.geo_long_changed ? property.geo_long_changed : property.geo_long))),
                  // parseFloat(changeFormat((zoom > 17 && property.geo_long_changed ? property.geo_lat_changed : property.geo_lat))),
                  parseFloat(changeFormat(property.geo_long)),
                  parseFloat(changeFormat(property.geo_lat)),
                ],
              },
            }) +
            (property.offsetChanged &&
            zoom > 17 &&
            new_points.find(
              element =>
                element.geometry.coordinates[0] === property.geo_long_changed &&
                element.geometry.coordinates[1] === property.geo_lat_changed
            )
              ? new_points.push({
                  type: "Feature",
                  property: property,
                  properties: {
                    cluster: false,
                    propId: property.id + Math.random,
                    address: property.address,
                    isCenterPoint: true,
                  },
                  geometry: {
                    type: "Point",
                    coordinates: [
                      parseFloat(changeFormat(property.geo_long)),
                      parseFloat(changeFormat(property.geo_lat)),
                    ],
                  },
                })
              : null)
          )
        }
      )

      if (
        boundsLeaflet.length === 0 &&
        coordinates.length === 0 &&
        polygonCoordinates.length === 0
      ) {
        if (
          properties?.objects?.length > 0 &&
          (backup?.objects?.length === 0 ||
            backup?.objects?.length === undefined)
        ) {
          //Primera carga
          centerDynamic(new_points)
        } else if (
          properties?.objects?.length > 0 &&
          backup?.objects?.length > 0
        ) {
          if (properties?.objects[0].id !== backup?.objects[0].id) {
            //Cuando pagino o filtro, que las propiedades son diferentes a las que estaban antes
            centerDynamic(new_points)
          }
        }
      }

      setPointsLeaflet(new_points)
      setBackup(properties)
    }, [properties, zoom, selected])

    useEffect(() => {
      // if(isFirstRender){
      //   if(map !== []){
      //     if(map.getZoom() > 16){
      //       console.log(map.getZoom())
      //       map.setView(map.getCenter(),15)
      //     }
      //   }
      // }
    }, [zoom])

    useEffect(() => {
      map.invalidateSize()
      if (polygonCoordinates.length === 0) {
        map.eachLayer(function (layer) {
          if (layer instanceof L.Path || layer instanceof L.Marker) {
            map.removeLayer(layer)
          }
        })
      }
    }, [viewId])

    useEffect(() => {
      // if(coordinates.length === 0){
      //   if(boundsLeaflet.length !== 0){
      //     setBoundsLeaflet([])
      //   }
      // }
    }, [coordinates])

    // get map bounds
    function updateMap() {
      const b = map.getBounds()
      setBounds([
        b.getSouthWest().lng,
        b.getSouthWest().lat,
        b.getNorthEast().lng,
        b.getNorthEast().lat,
      ])
      setZoom(map.getZoom())
    }

    const onMove = useCallback(() => {
      updateMap()
    }, [map])

    useEffect(() => {
      updateMap()
      setMapLeaflet(map)
      L.Control.DeleteButtonControl = L.Control.extend({
        onAdd: function (map) {
          // Verificar si el control ya existe
          var existingControl = document.querySelector(
            ".leaflet-bar.delete-control"
          )
          this.removePreviousButton()
          // if (existingControl) {
          //   return existingControl;
          // }

          var controlDiv = L.DomUtil.create("div", "leaflet-bar delete-control")
          controlDiv.innerHTML =
            '<button class="delete-button-leaflet"' +
            (polygonCoordinates.length === 0 && coordinates.length === 0
              ? "disabled"
              : "") +
            '> <i class="icon-trash"></i></button>'

          // Agregar evento click al botón para eliminar las capas de formas
          var deleteButton = controlDiv.querySelector(".delete-button-leaflet")
          deleteButton.addEventListener("click", function () {
            dispatch(REDUX_UPDATE_POLYGON_COORDINATES([]))
            setBoundsLeaflet([])
            map.eachLayer(function (layer) {
              if (layer instanceof L.Path) {
                map.removeLayer(layer)
              }
            })
          })
          return controlDiv
        },

        onRemove: function (map) {
          // No es necesario hacer nada aquí
        },

        removePreviousButton: function () {
          var previousButton = document.querySelector(
            ".leaflet-bar.delete-control"
          )
          if (previousButton) {
            previousButton.remove()
          }
        },
      })
      L.control.deleteButtonControl = function (opts) {
        return new L.Control.DeleteButtonControl(opts)
      }
      L.control
        .deleteButtonControl({
          position: "topright",
        })
        .addTo(map)
      L.drawLocal = {
        draw: {
          toolbar: {
            // #TODO: this should be reorganized where actions are nested in actions
            // ex: actions.undo  or actions.cancel
            actions: {
              title: "Cancelar",
              text: "Cancelar",
            },
            finish: {
              title: "Finalizar",
              text: "Finalizar",
            },
            undo: {
              title: "Deshacer último punto",
              text: "Deshacer último punto",
            },
            buttons: {
              polyline: "Polyline",
              polygon: "Poligono",
              rectangle: "- your text-",
              circle: "- your text-",
              marker: "- your text-",
              circlemarker: "- your text-",
            },
          },
          handlers: {
            circle: {
              tooltip: {
                start: "- your text-",
              },
              radius: "- your text-",
            },
            circlemarker: {
              tooltip: {
                start: "- your text-.",
              },
            },
            marker: {
              tooltip: {
                start: "- your text-.",
              },
            },
            polygon: {
              tooltip: {
                start: "Has clic para comenzar a trazar el área",
                cont: "Has otro clic para seguir trazando el área",
                end: "Has otro clic para seguir trazando el área",
              },
            },
            polyline: {
              error: "<strong>Error:</strong> shape edges cannot cross!",
              tooltip: {
                start: "Click to start drawing line.",
                cont: "Click to continue drawing line.",
                end: "Click last point to finish line.",
              },
            },
            rectangle: {
              tooltip: {
                start: "- your text-.",
              },
            },
            simpleshape: {
              tooltip: {
                end: "Release mouse to finish drawing.",
              },
            },
          },
        },
        edit: {
          toolbar: {
            actions: {
              save: {
                title: "Save changes",
                text: "Save",
              },
              cancel: {
                title: "Cancel editing, discards all changes",
                text: "Cancel",
              },
              clearAll: {
                title: "Clear all layers",
                text: "Clear All",
              },
            },
            buttons: {
              edit: "Edit layers",
              editDisabled: "No layers to edit",
              remove: "Delete layers",
              removeDisabled: "No layers to delete",
            },
          },
          handlers: {
            edit: {
              tooltip: {
                text: "Drag handles or markers to edit features.",
                subtext: "Click cancel to undo changes.",
              },
            },
            remove: {
              tooltip: {
                text: "Click on a feature to remove.",
              },
            },
          },
        },
      }
    }, [map, polygonCoordinates])

    useEffect(() => {
      map.on("move", onMove)
      return () => {
        map.off("move", onMove)
      }
    }, [map, onMove])

    useEffect(() => {
      let new_points = []
      reCalculateCoordinateMarkers(properties?.objects || properties).map(
        property => {
          property.development ? (
            <>
              {new_points.find(
                element =>
                  element.property.development?.id ===
                    property.development?.id &&
                  property.development?.display_on_web
              )
                ? null
                : new_points.push({
                    type: "Feature",
                    property: property,
                    properties: {
                      cluster: false,
                      propId: property.id,
                      address: property.address,
                    },
                    geometry: {
                      type: "Point",
                      coordinates: [
                        parseFloat(
                          changeFormat(
                            property.geo_long_changed
                              ? property.geo_long_changed
                              : property.geo_long
                          )
                        ),
                        parseFloat(
                          changeFormat(
                            property.geo_lat_changed
                              ? property.geo_lat_changed
                              : property.geo_lat
                          )
                        ),
                      ],
                    },
                  })}
            </>
          ) : false ? null : (
            new_points.push({
              type: "Feature",
              property: property,
              properties: {
                cluster: false,
                propId: property.id,
                address: property.address,
              },
              geometry: {
                type: "Point",
                coordinates: [
                  parseFloat(
                    changeFormat(
                      zoom > 27 && property.geo_long_changed
                        ? property.geo_long_changed
                        : property.geo_long
                    )
                  ),
                  parseFloat(
                    changeFormat(
                      zoom > 27 && property.geo_long_changed
                        ? property.geo_lat_changed
                        : property.geo_lat
                    )
                  ),
                ],
              },
            }) +
            (property.offsetChanged &&
            zoom > 27 &&
            new_points.find(
              element =>
                element.geometry.coordinates[0] === property.geo_long_changed &&
                element.geometry.coordinates[1] === property.geo_lat_changed
            )
              ? new_points.push({
                  type: "Feature",
                  property: property,
                  properties: {
                    cluster: false,
                    propId: property.id + Math.random,
                    address: property.address,
                    isCenterPoint: true,
                  },
                  geometry: {
                    type: "Point",
                    coordinates: [
                      parseFloat(changeFormat(property.geo_long)),
                      parseFloat(changeFormat(property.geo_lat)),
                    ],
                  },
                })
              : null)
          )
        }
      )

      if (selected === 0) {
        // // // // // centerDynamic(new_points)
      }
    }, [selected])

    const { clusters: leafletClusters, supercluster: leafletSuperCluster } =
      useSupercluster({
        points: pointsLeaflet,
        bounds,
        zoom,
        options: { radius: 100, maxZoom: 17 },
      })

    const getExpansionZoom = cluster => {
      const currentZoom = map.getZoom()
      const clusterExpansionZoom = supercluster.getClusterExpansionZoom(
        cluster.id
      )
      let zoom_custom = currentZoom
      const [longitude, latitude] = cluster.geometry.coordinates
      for (let index = 0; index < clusterExpansionZoom - currentZoom; index++) {
        zoom_custom += 1
        map.setView([latitude, longitude], zoom_custom, {
          duration: 0.7, // Duración de la animación en segundos
          easeLinearity: 0, // Controla la suavidad de la animación (valor entre 0 y 1)
        })
      }
      return Math.min(clusterExpansionZoom, currentZoom + 1)
    }

    return leafletClusters.map(cluster => {
      const [longitude, latitude] = cluster.geometry.coordinates
      const {
        cluster: isCluster,
        point_count: pointCount,
        isCenterPoint: centerPoint,
      } = cluster.properties
      if (isCluster) {
        return (
          <MarkerLeaflet
            key={`cluster-${cluster.id}`}
            position={[latitude, longitude]}
            icon={fetchIcon(
              pointCount,
              10 + (pointCount / pointsLeaflet.length) * 40
            )}
            eventHandlers={{
              click: () => {
                // getExpansionZoom(cluster)
                const expansionZoom = Math.min(
                  supercluster.getClusterExpansionZoom(cluster.id),
                  maxZoom
                )
                if (expansionZoom > 17) {
                  map.flyTo([latitude, longitude], expansionZoom, {
                    duration: 0.5, // Duración de la animación en segundos
                    easeLinearity: 0, // Controla la suavidad de la animación (valor entre 0 y 1)
                  })
                } else {
                  map.setView([latitude, longitude], expansionZoom, {
                    animate: true,
                  })
                }
                // map.panTo({ lat: latitude, lng: longitude });
              },
            }}
          />
        )
      }
      return (
        <CustomMarker
          cluster={cluster}
          key={`crime-${cluster.properties.propId}`}
          position={[latitude, longitude]}
        ></CustomMarker>
      )
    })
  }

  const handleShapeDelete = e => {
    dispatch(REDUX_UPDATE_POLYGON_COORDINATES([]))
  }

  const handleShapeCreated = e => {
    let polygon = []
    //Obtengo las coordenadas del polygon
    e.layer._latlngs[0].map((point, index) =>
      polygon.push({ lat: point.lat, lng: point.lng })
    )
    dispatch(REDUX_UPDATE_POLYGON_COORDINATES(polygon))
  }

  const handleShapeEdited = event => {
    const editedLayers = event.layers
    let polygon = []
    editedLayers.eachLayer(layer => {
      const coordinates = layer.getLatLngs() // Obtén las coordenadas actualizadas
      //Obtengo las coordenadas del polygon
      coordinates.map((point, index) =>
        point.map(coord => {
          polygon.push({ lat: coord.lat, lng: coord.lng })
        })
      )
    })
    dispatch(REDUX_UPDATE_POLYGON_COORDINATES(polygon))
    dispatch(REDUX_UPDATE_DRAWN_POLYGON(poly))
  }

  const updateBoundsLeaflet = () => {
    if (coordinates.length > 0) {
      return setBoundsLeaflet([])
    }
    const bounds = mapLeaflet.getBounds()
    setBoundsLeaflet([
      bounds.getNorthWest().lng,
      bounds.getSouthEast().lng,
      bounds.getSouthEast().lat,
      bounds.getNorthWest().lat,
    ])
  }

  useEffect(() => {
    if (boundsLeaflet !== []) {
      dispatch(changeOffsetPropertiesAction(0))
      setCoordinatesCheck(boundsLeaflet)
      dispatch(REDUX_UPDATE_COORDINATES(boundsLeaflet))
    }
  }, [boundsLeaflet])

  $(document).ready(function () {
    // Variable para almacenar el estado del mouse
    var mouseHover = false

    // Detectar el ingreso del mouse al elemento
    $("#sidebarElement").on("mouseenter", function () {
      mouseHover = true
    })

    // Detectar la salida del mouse del elemento
    $("#sidebarElement").on("mouseleave", function () {
      mouseHover = false
    })

    // Variable de control para verificar si se puede ejecutar el evento
    var canExecuteScrollEvent = true

    // Detectar el scroll en el elemento
    $("#sidebarElement").scroll(function () {
      // Verificar si se puede ejecutar el evento
      if (canExecuteScrollEvent && mouseHover) {
        // Desactivar la ejecución del evento durante tres segundos
        canExecuteScrollEvent = false

        if (selected !== 0) {
          dispatch(changeSelectedAction(0))
        }

        // Activar la ejecución del evento después de tres segundos
        setTimeout(function () {
          canExecuteScrollEvent = true
        }, 3000)
      }
    })
  })

  return (
    <div
      className={
        "d-flex wraper-map-view " +
        (properties?.meta?.total_count < 50 || polygonCoordinates.length > 0
          ? "full-height"
          : "")
      }
    >
      <div
        id="grid-map"
        className={"position-relative " + (viewId !== 0 ? "not-visible" : "")}
      >
        <div
          // onScroll={() =>
          //   selected !== 0 && !scrolling && resetSelectedAndCenterMap()
          // }
          id="sidebarElement"
          className={"sidebar-properties " + (sidebar ? "" : "close-sidebar")}
        >
          {/* <div onClick={() => setSidebar(!sidebar) + toggleFilterBar()} className="open-handle">{"<"}</div> */}
          <div className="sidebar-properties-header pt-2 d-flex">
            <div className="section-title">
              {(isLoadingProperties || isFetchingProperties) && (
                <h6>Cargando propiedades..</h6>
              )}
              {!isLoadingProperties && !isFetchingProperties && (
                <h6 className="mb-0">
                  {isLoadingProperties || isFetchingProperties
                    ? "Cargando"
                    : properties?.meta?.total_count}{" "}
                  {getType(filters)?.length > 0
                    ? textTypes(getType(filters)) + " en "
                    : "Propiedades en"}{" "}
                  <span className="">
                    {" " + textUpper(getOperationView(filters))}
                  </span>
                </h6>
              )}
              {/* <h5>{loading ? 'Cargando' : totalCount} resultados totales de búsqueda. </h5> */}
            </div>
            <div
              class={
                "justify-content-end d-flex align-items-center mb-4 mb-lg-0 me-3 " +
                (properties?.objects?.length === 0 &&
                  !isLoadingProperties &&
                  !isFetchingProperties &&
                  " d-none")
              }
              id="orderBy"
            >
              Ordenar por:
              <div className="content-select">
                <select
                  ref={selectorOrder}
                  onChange={() => traductorSelect()}
                  className="text-end"
                  name="orderby"
                  id="sort"
                >
                  <option value="2">Publicaciones más recientes</option>
                  <option value="3">Publicaciones más antiguas</option>
                  <option value="0">Mayor precio</option>
                  <option value="1">Menor precio</option>
                  <option value="4">Mayor superficie</option>
                  <option value="5">Menor superficie</option>
                </select>
                <i />
              </div>
            </div>
          </div>
          {isLoadingProperties || isFetchingProperties ? (
            [1, 2, 3, 4].map(element => (
              <Card_Property grid_map={true} skeleton={true} />
            ))
          ) : (
            <div className="sidebar-properties-body">
              {getLimit(properties?.objects)?.length === 0 &&
                !isLoadingProperties &&
                !isFetchingProperties && (
                  <h5 className="text-center mt-lg-5 mt-3">
                    No hay resultados para esta búsqueda.
                  </h5>
                )}
              {getLimit(properties?.objects).map((property, index) =>
                // (properties?.objects?.find(element => element.id === selected)?.development?.id > 0 &&
                // (properties?.objects?.find(element => element.id === selected)?.development?.display_on_web) ||
                property.id === selected ||
                selected === 0 ||
                selected === "null" ||
                !selected ? (
                  <div className={index !== 0 && "mt-3"}>
                    <Card_Property
                      key={index}
                      map={
                        realEstate.keys.google_map === "" ? mapLeaflet : mapRef
                      }
                      setZoom={setZoom}
                      handlerClick={handlerClick}
                      isLeaflet={realEstate.keys.google_map === ""}
                      grid_map={true}
                      property={property}
                    />
                    <hr />
                  </div>
                ) : (
                  <div className="mt-3">
                    <Card_Property
                      map={
                        realEstate.keys.google_map === "" ? mapLeaflet : mapRef
                      }
                      setZoom={setZoom}
                      handlerClick={handlerClick}
                      isLeaflet={realEstate.keys.google_map === ""}
                      opacity={true}
                      grid_map={true}
                      property={property}
                      key={index}
                    />
                    <hr />
                  </div>
                )
              )}
              {getLimit(properties?.objects).filter(
                element => element.id === selected
              ).length === 0 &&
                selected !== 0 && (
                  <div className={"mt-3"}>
                    <Card_Property
                      map={
                        realEstate.keys.google_map === "" ? mapLeaflet : mapRef
                      }
                      setZoom={setZoom}
                      handlerClick={handlerClick}
                      isLeaflet={realEstate.keys.google_map === ""}
                      grid_map={true}
                      property={properties?.objects?.find(
                        element => element.id === selected
                      )}
                    />
                    <hr />
                  </div>
                )}
              {maxPropertiesLoaded < properties?.objects?.length && (
                <div className="w-100 d-flex justify-content-center">
                  <div
                    onClick={() =>
                      setMaxPropertiesLoaded(maxPropertiesLoaded + 50)
                    }
                    className="btn d-inline-block btn-red mx-auto"
                  >
                    Cargar más propiedades
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div
        className="modal fade modal-card"
        id={"exampleModal"}
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog d-flex justify-content-center align-items-center modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {selected ? (
              properties?.objects?.find(element => element.id === selected)
                ?.development?.id > 0 &&
              properties?.objects?.find(element => element.id === selected)
                ?.development?.display_on_web ? (
                <Card_Development
                  inMap={true}
                  unities={searchUnitiesInResults(
                    properties?.objects?.find(
                      element => element.id === selected
                    )?.development?.id
                  )}
                  development={
                    properties?.objects?.find(
                      element => element.id === selected
                    )?.development
                  }
                />
              ) : (
                <Card_Property
                  inMap={true}
                  property={properties?.objects?.find(
                    element => element.id === selected
                  )}
                  key={selected}
                />
              )
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <div
        className={"map-google " + (viewId === 1 && "full-map")}
        style={{ position: "relative", overflow: "hidden" }}
      >
        <div className="wrapper-map position-relative">
          {!isLoadingProperties && (
            <>
              {realEstate.keys.google_map !== "" ? (
                <>
                  <GoogleMapReact
                    options={mapOptions}
                    bootstrapURLKeys={{
                      key: realEstate.keys.google_map,
                      libraries: ["drawing"].join(","),
                      v: "3.32",
                    }}
                    libraries={["geometry", "drawing"]}
                    zoom={zoom}
                    center={center}
                    // disableDoubleClickZoom={false}
                    disableDoubleClickZoom={false}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map, maps }) => {
                      mapRef.current = map
                      google.current = maps
                      handleGoogleMapApi(map, maps)
                    }}
                    onChange={({ zoom, bounds }) => {
                      setZoom(zoom)
                      setBounds([
                        bounds.nw.lng, // Oeste
                        bounds.se.lat, // Norte
                        bounds.se.lng, // Este
                        bounds.nw.lat, // Norte
                      ])
                      setMapBorder([
                        bounds.nw.lng,
                        bounds.se.lng,
                        bounds.se.lat,
                        bounds.nw.lat,
                      ])
                    }}
                  >
                    {points.length > 0 &&
                      clusters.map(cluster => {
                        const [longitude, latitude] =
                          cluster.geometry.coordinates
                        const {
                          cluster: isCluster,
                          point_count: pointCount,
                          isCenterPoint: centerPoint,
                        } = cluster.properties
                        if (isCluster) {
                          return (
                            <Marker
                              key={`cluster-${cluster.id}`}
                              lat={latitude}
                              lng={longitude}
                            >
                              <div
                                className={
                                  "cluster-marker " +
                                  (selected !== 0 && "opacity-cluster")
                                }
                                style={{
                                  width: `${
                                    10 + (pointCount / points.length) * 20
                                  }px`,
                                  height: `${
                                    10 + (pointCount / points.length) * 20
                                  }px`,
                                }}
                                onClick={() => {
                                  const expansionZoom = Math.min(
                                    supercluster.getClusterExpansionZoom(
                                      cluster.id
                                    ),
                                    20
                                  )
                                  getExpansionZoom(cluster)
                                  // mapRef.current.setZoom(expansionZoom);
                                  mapRef.current.panTo({
                                    lat: latitude,
                                    lng: longitude,
                                  })
                                }}
                              >
                                {pointCount}
                              </div>
                            </Marker>
                          )
                        }
                        return (
                          <Marker
                            key={`crime-${cluster.properties.propId}`}
                            lat={latitude}
                            lng={longitude}
                          >
                            <button
                              data-bs-toggle="modal"
                              data-bs-target={
                                cluster.property.development !== null &&
                                cluster.property.development.display_on_web &&
                                searchUnitiesInResults(
                                  cluster.property.development?.id
                                )?.length > 0 &&
                                "#exampleModal"
                              }
                              onClick={() =>
                                (viewId === 0 ? setMenu(false) : "") +
                                openModal(
                                  cluster.property.development !== null &&
                                    cluster.property.development
                                      .display_on_web &&
                                    searchUnitiesInResults(
                                      cluster.property.development?.id
                                    )?.length > 0
                                ) +
                                dispatch(
                                  changeSelectedAction(
                                    cluster.properties.propId
                                  )
                                ) +
                                scrollOnGrid(cluster.properties.propId) +
                                addMarker(cluster.properties.propId)
                              }
                              id={
                                "marker-" +
                                (cluster.property.development?.id > 0 &&
                                cluster.property.development.display_on_web
                                  ? cluster.property.development?.id
                                  : cluster.properties.propId)
                              }
                              className={
                                (cluster.properties.isCenterPoint
                                  ? " center-marker "
                                  : "") +
                                (viewId === 1
                                  ? "d-none"
                                  : "d-none d-lg-block") +
                                " crime-marker " +
                                (filters.operation.includes("venta")
                                  ? " venta-marker "
                                  : "alquiler-marker ") +
                                (selected?.toString() !== "0" &&
                                cluster?.properties?.propId.toString() !==
                                  selected?.toString()
                                  ? " opacity-marker "
                                  : "") +
                                (selected?.toString() ===
                                cluster?.properties?.propId.toString()
                                  ? " selected-marker "
                                  : "") +
                                (" marker-" +
                                  (cluster.property.development?.id > 0
                                    ? cluster.property.development?.id
                                    : cluster.properties.propId)) +
                                " " +
                                (cluster.property.development !== null &&
                                cluster.property.development.display_on_web &&
                                searchUnitiesInResults(
                                  cluster.property.development?.id
                                )?.length > 0
                                  ? " is_development"
                                  : "")
                              }
                            >
                              <div
                                className={
                                  (cluster.property.offsetChanged
                                    ? " is-modify-marker "
                                    : " ") +
                                  " center " +
                                  (checkMarker(
                                    cluster.property.development?.id?.length > 1
                                      ? cluster.property.development?.id
                                      : cluster.properties.propId
                                  )
                                    ? " active "
                                    : "")
                                }
                              >
                                <i
                                  className={
                                    (cluster.property.development !== null &&
                                    cluster.property.development
                                      .display_on_web &&
                                    searchUnitiesInResults(
                                      cluster.property.development?.id
                                    )?.length > 0
                                      ? " icon-marker-emprendimiento "
                                      : " icon-marker ") +
                                    (checkMarker(
                                      cluster.property.development?.id?.length >
                                        1
                                        ? cluster.property.development?.id
                                        : cluster.properties.propId
                                    )
                                      ? " active "
                                      : "")
                                  }
                                ></i>
                                {filters.operation.includes("venta") && (
                                  <h5>
                                    {cluster.property.development?.id > 0 &&
                                    searchUnitiesInResults(
                                      cluster.property.development?.id
                                    )?.length > 0 &&
                                    cluster.property.development.display_on_web
                                      ? searchUnitiesInResults(
                                          cluster.property.development?.id
                                        )?.length
                                      : getPriceForMarker(
                                          getPrices(cluster.property, "venta")
                                        )}
                                  </h5>
                                )}
                                {filters.operation.includes("alquiler") && (
                                  <h5>
                                    {cluster.property.development?.id > 0 &&
                                    searchUnitiesInResults(
                                      cluster.property.development?.id
                                    )?.length > 0 &&
                                    cluster.property.development.display_on_web
                                      ? searchUnitiesInResults(
                                          cluster.property.development?.id
                                        )?.length
                                      : getPriceForMarker(
                                          getPrices(
                                            cluster.property,
                                            "alquiler"
                                          )
                                        )}
                                  </h5>
                                )}
                                {filters.operation.includes("temporario") && (
                                  <h5>
                                    {cluster.property.development?.id > 0 &&
                                    searchUnitiesInResults(
                                      cluster.property.development?.id
                                    )?.length > 0 &&
                                    cluster.property.development.display_on_web
                                      ? searchUnitiesInResults(
                                          cluster.property.development?.id
                                        )?.length
                                      : getPriceForMarker(
                                          getPrices(
                                            cluster.property,
                                            "temporario"
                                          )
                                        )}
                                  </h5>
                                )}
                              </div>
                              <div
                                className={
                                  "delete-selected " +
                                    cluster?.properties?.propId.toString() !==
                                  selected?.toString()
                                    ? " enabled "
                                    : ""
                                }
                              >
                                <i></i>
                                <i></i>
                              </div>
                            </button>
                            <button
                              data-bs-toggle="modal"
                              data-bs-target="#exampleModal"
                              onClick={() =>
                                openModal() +
                                dispatch(
                                  changeSelectedAction(
                                    cluster.properties.propId
                                  )
                                ) +
                                scrollOnGrid(cluster.properties.propId) +
                                addMarker(cluster.properties.propId)
                              }
                              id={
                                "marker-" +
                                (cluster.property.development?.id > 0
                                  ? cluster.property.development?.id
                                  : cluster.properties.propId)
                              }
                              className={
                                (cluster.properties.isCenterPoint
                                  ? " center-marker "
                                  : "") +
                                (viewId === 1
                                  ? "d-block"
                                  : "d-block d-lg-none") +
                                " crime-marker " +
                                (filters.operation.includes("venta")
                                  ? " venta-marker "
                                  : "alquiler-marker ") +
                                (selected?.toString() !== "0" &&
                                cluster?.properties?.propId.toString() !==
                                  selected?.toString()
                                  ? " opacity-marker "
                                  : "") +
                                (selected?.toString() ===
                                cluster?.properties?.propId.toString()
                                  ? " selected-marker "
                                  : "") +
                                (" marker-" +
                                  (cluster.property.development?.id > 0
                                    ? cluster.property.development?.id
                                    : cluster.properties.propId)) +
                                " " +
                                (cluster.property.development !== null &&
                                cluster.property.development.display_on_web &&
                                searchUnitiesInResults(
                                  cluster.property.development?.id
                                )?.length > 0
                                  ? " is_development"
                                  : "")
                              }
                            >
                              <div
                                className={
                                  (cluster.property.offsetChanged
                                    ? " is-modify-marker "
                                    : " ") +
                                  " center " +
                                  (checkMarker(
                                    cluster.property.development?.id?.length > 1
                                      ? cluster.property.development?.id
                                      : cluster.properties.propId
                                  )
                                    ? " active "
                                    : "")
                                }
                              >
                                <i
                                  className={
                                    (cluster.property.development !== null &&
                                    cluster.property.development
                                      .display_on_web &&
                                    searchUnitiesInResults(
                                      cluster.property.development?.id
                                    )?.length > 0
                                      ? " icon-marker-emprendimiento "
                                      : " icon-marker ") +
                                    (checkMarker(
                                      cluster.property.development?.id?.length >
                                        1
                                        ? cluster.property.development?.id
                                        : cluster.properties.propId
                                    )
                                      ? " active "
                                      : "")
                                  }
                                ></i>
                                {filters.operation.includes("venta") && (
                                  <h5>
                                    {cluster.property.development?.id > 0 &&
                                    searchUnitiesInResults(
                                      cluster.property.development?.id
                                    )?.length > 0 &&
                                    cluster.property.development.display_on_web
                                      ? searchUnitiesInResults(
                                          cluster.property.development?.id
                                        )?.length
                                      : getPriceForMarker(
                                          getPrices(cluster.property, "venta")
                                        )}
                                  </h5>
                                )}
                                {filters.operation.includes("alquiler") && (
                                  <h5>
                                    {cluster.property.development?.id > 0 &&
                                    searchUnitiesInResults(
                                      cluster.property.development?.id
                                    )?.length > 0 &&
                                    cluster.property.development.display_on_web
                                      ? searchUnitiesInResults(
                                          cluster.property.development?.id
                                        )?.length
                                      : getPriceForMarker(
                                          getPrices(
                                            cluster.property,
                                            "alquiler"
                                          )
                                        )}
                                  </h5>
                                )}
                                {filters.operation.includes("temporario") && (
                                  <h5>
                                    {cluster.property.development?.id > 0 &&
                                    searchUnitiesInResults(
                                      cluster.property.development?.id
                                    )?.length > 0 &&
                                    cluster.property.development.display_on_web
                                      ? searchUnitiesInResults(
                                          cluster.property.development?.id
                                        )?.length
                                      : getPriceForMarker(
                                          getPrices(
                                            cluster.property,
                                            "temporario"
                                          )
                                        )}
                                  </h5>
                                )}
                              </div>
                            </button>
                          </Marker>
                        )
                      })}
                  </GoogleMapReact>
                  <div className="control-side">
                    <div className="content-button position-relative">
                      <button
                        disabled={
                          // (polygonCoordinates.length > 0 || barControllMap !== null) ||
                          // (coordinatesCheck?.length > 0 || coordinatesCheck !== undefined)
                          polygonCoordinates.length > 0 ||
                          barControllMap !== null ||
                          coordinatesCheck?.length > 0
                        }
                        id={"button-polygon"}
                        className={
                          "btn-action map-polygon-icon " +
                          (barControllMap === "polygon" && "active")
                        }
                        onClick={e => setBarControllMap("polygon")}
                      ></button>
                      <button
                        id="back-hand"
                        onClick={e => setBarControllMap(null)}
                        className={
                          "back-to-hand " +
                          (polygonCoordinates.length === 0 &&
                          barControllMap === "polygon"
                            ? ""
                            : "d-none")
                        }
                      >
                        <div></div>
                        <div></div>
                      </button>
                    </div>
                    <div className="content-button position-relative">
                      <button
                        disabled={
                          // (polygonCoordinates.length !== 0 && barControllMap !== null) ||
                          // (coordinatesCheck?.length !== 0 || coordinatesCheck !== undefined)
                          polygonCoordinates.length > 0 ||
                          barControllMap !== null ||
                          coordinatesCheck?.length > 0
                        }
                        id="button-pencil"
                        className={
                          "btn-action " +
                          (barControllMap === "pencil" && "active")
                        }
                        onClick={e =>
                          drawAction(e) +
                          setDrawing(!drawing) +
                          setBarControllMap("pencil")
                        }
                      >
                        <i className="icon-pencil"></i>
                      </button>
                      <button
                        id="back-hand_"
                        onClick={e => setBarControllMap(null)}
                        className={
                          "back-to-hand " +
                          (polygonCoordinates.length === 0 &&
                          barControllMap === "pencil"
                            ? ""
                            : "d-none")
                        }
                      >
                        <div></div>
                        <div></div>
                      </button>
                    </div>
                    {/* <button
                      className={"btn-searcher "}
                      onClick={() => centerMap(points)}
                    >
                     Centrar mapa
                    </button> */}
                    <button
                      disabled={polygonCoordinates.length !== 0}
                      className={
                        "btn-searcher " +
                        (mapBorder === coordinatesCheck
                          ? " disabled-map "
                          : "") +
                        (coordinatesCheck?.length > 0 ? " active" : "")
                      }
                      onClick={() => handleSearchProperties(true)}
                    >
                      Ver resultados en esta zona
                    </button>
                    <div className="content-button position-relative">
                      {/* <div className={"disabled-index " + (polygonCoordinates.length === 0 || coordinatesCheck === undefined ? 'z-index-top' : '')}></div> */}
                      <button
                        className={
                          "btn-trash " +
                          ((polygonCoordinates.length !== 0 ||
                            coordinatesCheck !== undefined ||
                            coordinatesCheck?.length > 0) &&
                            "red-trash")
                        }
                        style={{ lineHeight: "1" }}
                        id="clean"
                        onClick={e =>
                          e.preventDefault() +
                          cleanerPolygon() +
                          setBarControllMap(null) +
                          setSkipCenter(true)
                        }
                      >
                        <i className="icon-trash"></i>
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <MapContainer // Leaflet Map
                  className="markercluster-map"
                  center={[0, 0]}
                  zoom={10}
                  maxZoom={18}
                  scrollWheelZoom={false}
                  zoomControl={false} // Desactivamos el control de zoom predeterminado
                  zoomControlPosition="bottomright" // Posicionamos el control de zoom en la esquina inferior derecha
                >
                  <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" />
                  {/* <TileLayer
                    url="https://api.maptiler.com/maps/dataviz/256/{z}/{x}/{y}.png?key=fzW9HzAb6C93tDpePOno"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  /> */}
                  {/* <Freedraw mode={mode} eventHandlers={handlers} ref={freedrawRef} /> */}
                  <ZoomControl position="bottomright" />{" "}
                  {/* Agregamos nuestro propio control de zoom */}
                  <FeatureGroup>
                    {coordinates.length === 0 &&
                      polygonCoordinates.length === 0 && (
                        <EditControl
                          position="topright"
                          draw={{
                            rectangle: false,
                            circle: false,
                            polygon: true,
                            marker: false,
                            circlemarker: false,
                            polyline: false,
                          }}
                          delete={false}
                          className={"custom-draw-control "} // Agrega la clase CSS personalizada
                          onCreated={handleShapeCreated}
                          onEdited={handleShapeEdited}
                          onDeleted={handleShapeDelete}
                        />
                      )}
                    <button
                      // disabled={boundsLeaflet[0] === currentBoundsLeaflet[0] && boundsLeaflet[1] === currentBoundsLeaflet[1]}
                      disabled={coordinates.length > 0}
                      className={
                        "btn-searcher leaflet-searcher " +
                        (coordinates.length > 0 ? " delete " : "") +
                        (polygonCoordinates.length > 0 && "d-none")
                      }
                      onClick={() => updateBoundsLeaflet()}
                    >
                      {coordinates.length === 0 ? (
                        "Ver resultados en esta zona"
                      ) : (
                        <>
                          {properties?.meta?.total_count} resultados en esta
                          zona
                        </>
                      )}
                    </button>
                  </FeatureGroup>
                  <RenderMarkersLeaflet points={points} />
                </MapContainer>
              )}
            </>
          )}
          {isLoadingProperties || isFetchingProperties ? (
            <Loader width={"full"} />
          ) : (
            ""
          )}
        </div>
        <Paginate viewId={viewId} />
      </div>
    </div>
  )
}

export default connect(
  state => ({
    settings: state.settings,
    properties: state.properties.properties,
    offset: state.properties.offset,
    totalCount: state.properties.totalCount,
    selected: state.properties.selected,
    loading: state.properties.loading,
    orders: state.properties.orders,
    coordinates: state.properties.coordinates,
    polygonCoordinates: state.properties.polygonCoordinates,
    drawnPolygon: state.properties.drawnPolygon,
    filters: state.properties.filters,
  }),
  null
)(getMap)
